import { styles } from '../styles';

const SectionWrapper = (Component, idName, classExtend) =>
  function HOC() {
    return (
      <div className={`w-full ${classExtend ?? ''}`}>
        <section
          className={`${styles.padding} max-w-7xl mx-auto relative w-full h-full `}
        >
          <span className="hash-span" id={idName}>
            &nbsp;
          </span>
          <Component />
        </section>
      </div>
    );
  };

export default SectionWrapper;
